import { METHOD } from '../method'

export const API_INSTAGRAM = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/instagram',
        method: METHOD.GET,
    },
    URL_IMAGE_BACKGROUND: {
        api: '/v1/dashboard-admin/main-page/home-page/instagram/storage-url/attachment',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/instagram',
        method: METHOD.PUT,
    },
}
